import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type GatewayStatus = 'ONLINE' | 'OFFLINE' | 'UNKNOWN' | string;

/**
 * Gateway counterpart of {@code TrackerStatusBadgeComponent}. Same Wheere palette.
 */
@Component({
  selector: 'lib-gateway-status-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium" [class]="classes()">
      <span class="h-1.5 w-1.5 rounded-full" [class]="dotClasses()"></span>
      {{ label() }}
    </span>
  `,
})
export class GatewayStatusBadgeComponent {
  status = input.required<GatewayStatus | undefined>();

  protected readonly label = computed(() => this.status() ?? 'UNKNOWN');

  protected readonly classes = computed(() => {
    switch (this.status()) {
      case 'ONLINE':
        return 'bg-aquamarine-50 text-aquamarine-900';
      case 'OFFLINE':
        return 'bg-gray-100 text-gray-700';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  });

  protected readonly dotClasses = computed(() => {
    switch (this.status()) {
      case 'ONLINE':
        return 'bg-aquamarine-500';
      case 'OFFLINE':
        return 'bg-gray-400';
      default:
        return 'bg-gray-400';
    }
  });
}
